import React from 'react';

import cn from 'classnames';

import st from './CheckTypeCard.module.sass';

export function CheckTypeCard({
  title,
  subtitle,
  icon = null,
  iconClassName = '',
  onClick,
  disabled = false,
  tabIndex = 0,
}) {
  const handleKey = (e) => {
    if (disabled) return;
    if (e.key === 'Enter') {
      e.preventDefault();
      onClick?.(e);
    }
  };

  return (
    <div
      aria-disabled={disabled}
      aria-label={title}
      className={cn(st.Card, {
        [st.CardDisabled]: disabled,
      })}
      onClick={onClick}
      onKeyDown={handleKey}
      role="button"
      tabIndex={disabled ? -1 : tabIndex}
    >
      <div className={cn(st.IconBg, iconClassName)}>
        <div className={st.IconSlot}>{icon}</div>
      </div>

      <h6 className={st.Title}>{title}</h6>

      <div className={st.Subtitle}>
        <div style={{ whiteSpace: 'pre-line' }}>{subtitle}</div>
      </div>
    </div>
  );
}
